import { CRORE, LAKH } from '../utils';
import { inrAmount } from './inrAmount';

/** ≥1 Cr → "2.10 Cr", ≥1 lakh → "34.43 lac", else en-IN rupees ("82,385"). */
export const formatLacCr = (amount: number): string => {
    if (amount >= CRORE) return `${(amount / CRORE).toFixed(2)} Cr`;
    if (amount >= LAKH) return `${(amount / LAKH).toFixed(2)} lac`;
    return inrAmount(Math.round(amount));
};
